import Controller from '@ember/controller';
import { service } from '@ember/service';

import { ContentWrapper } from 'register-partners-js/react/components/content-wrapper';
import { MainLayout } from 'register-partners-js/react/components/layouts/main';
import { LogosBar } from 'register-partners-js/react/components/logos-bar/logos-bar';
import { welcomePromoBannerElement } from 'register-partners-js/react/components/welcome-promo-banner/welcome-promo-banner';

import styles from './styles.module.css';

export default class WelcomeController extends Controller {
  mainLayout = MainLayout;
  welcomePromoBanner = welcomePromoBannerElement;

  @service intl;

  logosBar = LogosBar;
  contentWrapper = ContentWrapper;

  get subtitle() {
    let { isEmbedded, legalFlow, organizationName } = this.model.redirection;

    if (legalFlow === 'qonto_invoicing') {
      return this.intl.t('qonto-pa.welcome.subtitle', { organization_name: organizationName });
    }

    if (isEmbedded) {
      return this.intl.t('existing-company.qonto-embed.welcome-screen.subtitle');
    }

    if (this.isExistingCompanyFlow) {
      return this.intl.t('existing-company.fast-track.welcome-screen.subtitle', {
        organization_name: organizationName,
      });
    }

    return this.intl.t('welcome.new-user.subtitle', { organization_name: organizationName });
  }

  get featuresList() {
    let { isAccountant, isEmbedded, legalFlow, partnerName } = this.model.redirection;

    if (legalFlow === 'qonto_invoicing') {
      return [
        this.intl.t('qonto-pa.welcome.features.e-invoicing'),
        this.intl.t('qonto-pa.welcome.features.invoice-sync'),
      ];
    }

    if (isEmbedded) {
      return [
        this.intl.t('existing-company.qonto-embed.welcome-screen.list.item.1', {
          htmlSafe: true,
          partner: partnerName,
        }),
        this.intl.t('existing-company.qonto-embed.welcome-screen.list.item.2', {
          htmlSafe: true,
          partner: partnerName,
        }),
        this.intl.t('existing-company.qonto-embed.welcome-screen.list.item.3', { htmlSafe: true }),
      ];
    }

    if (isAccountant) {
      return [
        this.intl.t('welcome.new-user.accountant.list.item.1'),
        this.intl.t('welcome.new-user.accountant.list.item.2'),
        this.intl.t('welcome.new-user.accountant.list.item.3'),
      ];
    }
    return [
      this.intl.t('welcome.new-user.list.item.1'),
      this.intl.t('welcome.new-user.list.item.2'),
      this.intl.t('welcome.new-user.list.item.3'),
    ];
  }

  get title() {
    let { legalFlow, ownerFirstName } = this.model.redirection;

    if (legalFlow === 'qonto_invoicing') {
      return this.intl.t('qonto-pa.welcome.title', {
        owner_first_name: ownerFirstName,
      });
    }

    return this.intl.t('welcome.new-user.title', {
      owner_first_name: ownerFirstName,
    });
  }

  get illustrationSrc() {
    let { legalFlow } = this.model.redirection;

    if (legalFlow === 'qonto_invoicing') {
      return 'illustrations/welcome-invoicing.png';
    }

    return 'illustrations/welcome.png';
  }

  get isExistingCompanyFlow() {
    let { legalFlow } = this.model.redirection;

    return legalFlow === 'existing_company';
  }

  get shouldShowPromoBanner() {
    let partnerName = this.model?.redirection?.partnerName?.toLowerCase();
    return partnerName?.includes('beglaubigt');
  }

  styles = styles;
}
